<template>
	<div v-if="show">
		<!--<button class="button" @click="refresh">refresh</button>-->
		<label class="text-uppercase">Program progress completion</label>
		<GChart
			type="ColumnChart"
			:data="chartData"
			:options="chartOptions"
			:events="chartEvents"
			ref="chart"
			@ready="onChartReady"
		/>
	</div>

</template>

<script>
	export default{
		props: ['course'],
		data : function(){
			return {
				show : false,
				chartData : [],
				chartOptions : {
					height: 250,
					chartArea:{width:'100%'},
					legend: {position: 'bottom', textStyle: {fontSize: 9}},
					colors: ['#ccc','#db504a','#ffd166' ,'#00777b', '#00ff00'],
					
				},
				chartEvents : {
					
				},
				chart :null,
				responsive : false,
				colors : null
			}
		},

		created : function(){

			this.colors = this.config.COLORS;

			this.chartOptions.colors = [
				this.colors.RED,
				this.colors.ORANGE,
				this.colors.YELLOW,
				this.colors.LIGHT_GREEN,
				this.colors.GREEN
			];

			var vue_instance = this;
			this.chartEvents = {
				select : () => {
					var selection = this.chart.getSelection();

					console.log(selection);
					var row, column = null;

					if(selection.length == 0){
						vue_instance.emitSelection('none', {
							row : null, 
							column : null
						});
					}else{
						vue_instance.emitSelection('filter-progress-completion', {
							row : selection[0].row,
							column : selection[0].column
						});
					}
				}
			}
			this.iniChart();
		},
		methods : {
			iniChart : function(){
				var params = {
					filters : {
						page_loading : false
					},
					id : this.course
				}
				this.$store.dispatch('getprogramProgressCompletion', params).then((res) => {
					
					this.chartData = [
				        ['h', "0-24%", "25%-49%", "50%-74%", "75%-99%", "100%"],
				        res.data.data,
				      ];


					this.show = true;
				}).catch((error) => {
					console.log(error);
				});
			},
			refresh : function(){
				this.iniChart();
			},
			onChartReady : function(chart, google){
				this.chart = chart;
			},
			emitSelection(type, data){
				this.$emit('filter', {
					type : type,
					row : data.row,
					column : data.column
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/charts/ProgramProgressCompletionComponent.vue